import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import DropDownInputField from "../../components/forms/DropDownInputField";
import FormError from "../../components/forms/FormError";
import {List} from "immutable";

function toUpperCase(val) {
  return val && val.toUpperCase();
}

class BillingAddressForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    let stateProvinceInput = null;
    if (this.props.showStateProvince) {
      stateProvinceInput = <Field
                              label="State / Province"
                              name="addressStateProvince"
                              component={TextInputField}
                              serverError={this.props.errors.addressStateProvince}
                              />
    }
    if (this.props.stateProvinces.size > 0) {
      stateProvinceInput = <Field
        label="State / Province"
        name="addressStateProvince"
        component={DropDownInputField}
        data={this.props.stateProvinces}
        valueKey="code"  
        titleKey="name"
        serverError={this.props.errors.addressStateProvince}
        />
      }

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Name"
              name="name"
              placeholder=""
              component={TextInputField}
              serverError={this.props.errors.name}
              />
            <Field
              label="Country"
              name="addressCountryCode"
              component={DropDownInputField}
              data={this.props.countries}
              valueKey="code"  
              titleKey="name" 
              serverError={this.props.errors.addressCountryCode}
              />
            <Field
              label="Address Line 1"
              name="addressAddressLine1"
              component={TextInputField}
              serverError={this.props.errors.addressAddressLine1}
              />
            <Field
              label="Address Line 2"
              name="addressAddressLine2"
              component={TextInputField}
              serverError={this.props.errors.addressAddressLine2}
              />
            <Field
              label="City"
              name="addressCity"
              component={TextInputField}
              serverError={this.props.errors.addressCity}
              />
            <Field
              label="Postal Code"
              name="addressPostcode"
              normalize={toUpperCase}
              component={TextInputField}
              serverError={this.props.errors.addressPostcode}
              />      

              {stateProvinceInput}

          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

BillingAddressForm.defaultProps = {
  stateProvinces: List([]),
  showStateProvince: true,
}

const ReduxForm = reduxForm({
  form: "BillingAddressForm"
})(BillingAddressForm);

export default ReduxForm;